/**
 * Utility library for using the clarity
 */
const clarity = {
  /**
   * Inititalizes clarity sdk
   */
  init() {
    (function(c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function() {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'h1r72r3ujz');
  },
  /**
   * Identify user clarity
   */
  identify({ id, email, name, phoneNumber }) {
    console.log('Testing clarity identify out');
    if (window.clarity) {
      console.log('Testing clarity identify in');
      window.clarity('consent');
      window.clarity('identify', email);
      window.clarity('set', 'id', id);
      window.clarity('set', 'name', name);
      window.clarity('set', 'phoneNumber', phoneNumber);
    }
  },
};

export default clarity;
